'use strict';

var AppDispatcher = require('../AppDispatcher'),
    ActionTypes = require('../constants/ActionTypes'),
    NotificationMessages = require('../constants/NotificationMessages'),
    NotificationStore = require('../stores/NotificationStore'),
    assign = require('react/lib/Object.assign'),
    invariant = require('react/lib/invariant'),
    _ = require('underscore');

var _hideTimeouts = [];

function findTimeouts(id, created) {
  return _.filter(_hideTimeouts, (n) => n.id === id && (!created || created === n.created));
}

function clearHideTimeout(id, created) {
  var timeouts = findTimeouts(id, created);
  _.each(timeouts, timeout => {
    clearTimeout(timeout.timeoutId);
  });
  _hideTimeouts = _.difference(_hideTimeouts, timeouts);
}

function setHideTimeout(id, created) {
  var duration = NotificationStore.getDuration(id);

  if (duration) {
    var timeoutId = setTimeout(() => {
      AppDispatcher.handleViewAction({
        type: ActionTypes.HIDE_NOTIFICATION,
        id: id,
        created: created
      });
    }, duration);

    _hideTimeouts.push({
      id: id,
      timeoutId: timeoutId,
      created: created
    });
  }
}

var NotificationActionCreators = {
  showNotification(id, options) {
    invariant(
      NotificationMessages.hasOwnProperty(id),
      'showNotification() accepts a constant from NotificationMessages. You passed %s',
      id
    );

    var created = Date.now();

    AppDispatcher.handleViewAction({
      type: ActionTypes.SHOW_NOTIFICATION,
      notification: assign({
        id: id,
        created: created
      }, options)
    });

    setHideTimeout(id, created);
  },

  hideNotification(id, created) {
    clearHideTimeout(id, created);

    AppDispatcher.handleViewAction({
      type: ActionTypes.HIDE_NOTIFICATION,
      id: id,
      created: created
    });
  }
};

module.exports = NotificationActionCreators;


/** WEBPACK FOOTER **
 ** ./actions/NotificationActionCreators.js
 **/